import { render } from "./OkxImport.vue?vue&type=template&id=70536f68&scoped=true"
import script from "./OkxImport.vue?vue&type=script&lang=js"
export * from "./OkxImport.vue?vue&type=script&lang=js"

import "./OkxImport.vue?vue&type=style&index=0&id=70536f68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70536f68"]])

export default __exports__